import React from 'react';
import { AppContext } from '../components/AppContext/AppContext';

export const useAppContext = () => {
    return React.useContext(AppContext);
};
